import React, { useState } from "react";
import useAuth from "../../../Hooks/useAuth";
import Popup from "../../../components/popup/Popup";
import {
  AdminPageTitle,
  AdminDetailFieldLabel,
  AdminSupportingText,
  AdminHeaderAction,
  AdminLinkAction,
  adminWizardInputClasses,
} from "../../AdminDashboard/shared/adminUx";
import {
  CUSTOMER_WIZARD_CONTENT_WIDE_CLASS,
  CUSTOMER_FORM_ACTION_ROW_END_CLASS,
  CUSTOMER_FORM_ACTION_ROW_BETWEEN_CLASS,
} from "../shared/customerLayoutSpec";

const ChangePassword = () => {
  const [step, setStep] = useState(1);
  const { setAuth } = useAuth();
  const [verify, setVerify] = useState(false);
  const [ShowCrossButton] = useState(true);

  return (
    <>
      <div className={CUSTOMER_WIZARD_CONTENT_WIDE_CLASS}>
        <div className="space-y-5">
          <div className="space-y-1">
            <AdminDetailFieldLabel htmlFor="new-password">New password</AdminDetailFieldLabel>
            <input
              id="new-password"
              type="password"
              placeholder="Your new secure password"
              className={`${adminWizardInputClasses(false)} lg:bg-pastalblue`}
            />
          </div>
          <div className="space-y-1">
            <AdminDetailFieldLabel htmlFor="confirm-password">Confirm password</AdminDetailFieldLabel>
            <input
              id="confirm-password"
              type="password"
              placeholder="Re-enter your new password"
              className={`${adminWizardInputClasses(false)} lg:bg-pastalblue`}
            />
          </div>
          <div className={CUSTOMER_FORM_ACTION_ROW_END_CLASS}>
            <AdminHeaderAction type="button" onClick={() => setVerify(true)}>
              Reset
            </AdminHeaderAction>
          </div>
        </div>
      </div>

      {verify && (
        <Popup
          setTrigger={() => {
            setVerify(false);
            setStep(1);
          }}
          ShowCrossButton={ShowCrossButton}
        >
          {step === 1 && (
            <>
              <AdminPageTitle className="text-center pb-0 mb-10 mt-20 xl:mt-40">
                Verify your password reset
              </AdminPageTitle>
              <div className="grid grid-cols-12 w-[300px] sm:w-[400px] mx-auto">
                <div className="col-span-12">
                  <AdminSupportingText className="text-offblack block">
                    A verification code has been sent to your registered email. Please enter the
                    code below to continue resetting your password and ensure enhanced account
                    security.
                  </AdminSupportingText>
                  <form onSubmit={(e) => e.preventDefault()}>
                    <div className="mt-12 space-y-1">
                      <AdminDetailFieldLabel htmlFor="verification-code">
                        Verification code
                      </AdminDetailFieldLabel>
                      <input
                        id="verification-code"
                        type="text"
                        name="verificationCode"
                        placeholder="Enter the 5-digit verification code"
                        className={`${adminWizardInputClasses(false)} bg-white`}
                      />
                      <AdminSupportingText className="text-mediumgray mt-5 block">
                        Entering the correct verification code ensures that only you can change
                        your password. If you encounter any issues, please reach out to our support
                        team for assistance.
                      </AdminSupportingText>
                    </div>

                    <div className={CUSTOMER_FORM_ACTION_ROW_BETWEEN_CLASS}>
                      <AdminLinkAction type="button">Resend</AdminLinkAction>
                      <AdminHeaderAction
                        type="button"
                        onClick={() => {
                          setStep(2);
                          setTimeout(() => {
                            setAuth({
                              user: null,
                              roles: null,
                              accessToken: "",
                            });
                            localStorage.removeItem("LoginSession");
                          }, 4000);
                        }}
                      >
                        Verify
                      </AdminHeaderAction>
                    </div>
                  </form>
                </div>
              </div>
            </>
          )}
          {step === 2 && (
            <>
              <AdminPageTitle className="text-center pb-0 text-offblack mb-10 mt-20 xl:mt-40">
                Password reset successful
              </AdminPageTitle>
              <div className="w-[300px] sm:w-[400px] mx-auto">
                <AdminSupportingText className="text-offblack block">
                  Your password has been successfully updated. For your security, you have been
                  logged out of all devices. Please log in again using your new password.
                </AdminSupportingText>
              </div>
            </>
          )}
        </Popup>
      )}
    </>
  );
};

export default ChangePassword;
